import { useFeishuContext } from '../provider'

/**
 * 画像已加载且当前账号的 visible_workbenches 不含本工作台 key 时为 true。
 * 用于除秘书台外的各工作台壳层：直接打开 URL 时展示无权限页，而非空白或全量侧栏。
 */
export function useWorkbenchAccessDenied(workstationKey: string): boolean {
  const ctx = useFeishuContext()
  return Boolean(
    !ctx.profileLoading && ctx.profile && !ctx.canAccessWorkbench(workstationKey),
  )
}
